import type { IntlShape } from 'react-intl';

export const COLOR_PALETTE = [
  '#699AFF',
  '#F7D96C',
  '#FBA05E',
  '#6C6EC9',
  '#69C0FF',
  '#9BDA5D',
  '#5DBCDA',
  '#5DD3DA',
  '#323232',
  '#979797',
];

export const BARCHART_COLOR = '#1684D0';
export const UNACTIVE_CHART_COLOR = '#D8D8D8';
export const SEARCH_COUNT_SINGLE_VALUE_ID = 'search_count_chart';
export const getIntervals = (intl: IntlShape) => [
  {
    label: intl.formatMessage({
      id: 'Charts.intervalDay',
      defaultMessage: 'Day',
      description: 'Chart interval option for day',
    }),
    value: 'DAY',
  },
  {
    label: intl.formatMessage({
      id: 'Charts.intervalWeek',
      defaultMessage: 'Week',
      description: 'Chart interval option for week',
    }),
    value: 'WEEK',
  },
  {
    label: intl.formatMessage({
      id: 'Charts.intervalMonth',
      defaultMessage: 'Month',
      description: 'Chart interval option for month',
    }),
    value: 'MONTH',
  },
  {
    label: intl.formatMessage({
      id: 'Charts.intervalQuarter',
      defaultMessage: '3 months',
      description: 'Chart interval option for quarter (3 months)',
    }),
    value: 'QUARTER',
  },
  {
    label: intl.formatMessage({
      id: 'Charts.intervalYear',
      defaultMessage: 'Year',
      description: 'Chart interval option for year',
    }),
    value: 'YEAR',
  },
];

export const getChartWidths2Columns = (intl: IntlShape) => [
  {
    value: '1',
    label: intl.formatMessage({
      id: 'Charts.halfWidth',
      defaultMessage: 'Half width',
      description: 'Chart width option for half width',
    }),
  },
  {
    value: '2',
    label: intl.formatMessage({
      id: 'Charts.fullWidth',
      defaultMessage: 'Full',
      description: 'Chart width option for full width',
    }),
  },
];
export const getChartWidths3Columns = (intl: IntlShape) => [
  {
    value: '1',
    label: intl.formatMessage({
      id: 'Charts.oneThirdWidth',
      defaultMessage: 'One third',
      description: 'Chart width option for one third width',
    }),
  },
  {
    value: '2',
    label: intl.formatMessage({
      id: 'Charts.twoThirdsWidth',
      defaultMessage: 'Two thirds',
      description: 'Chart width option for two thirds width',
    }),
  },
  {
    value: '3',
    label: intl.formatMessage({
      id: 'Charts.fullWidth3Col',
      defaultMessage: 'Full',
      description: 'Chart width option for full width in 3 column layout',
    }),
  },
];

export const getChartTypes = (intl: IntlShape) => [
  {
    value: 'vertical_bar',
    label: intl.formatMessage({
      id: 'Charts.verticalBarChart',
      defaultMessage: 'Vertical Bar chart',
      description: 'Chart type option for vertical bar chart',
    }),
  },
  {
    value: 'line',
    label: intl.formatMessage({
      id: 'Charts.lineChart',
      defaultMessage: 'Line chart',
      description: 'Chart type option for line chart',
    }),
  },
];

export const MAX_BUCKET_LENGTH = 156;
